import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCulinaryStudioArticleCategories } from '../../api/fetch-culinary-studio-article-categories';

export const fetchCulinaryStudioArticleCategoriesThunk = createAsyncThunk(
    'fetchCulinaryStudioArticleCategories',
    async () => fetchCulinaryStudioArticleCategories(),
);
